import { EventName, EventProperties } from '@/lib/tracking/types';

async function postData<T>({ url, data }: { url: string; data: T }) {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
    // Login events are sent right before a full-page redirect; keepalive lets the
    // request finish after the page unloads instead of being cancelled.
    keepalive: true,
  });

  if (!response.ok) {
    throw new Error(`Failed to POST ${url}: ${response.status} ${response.statusText}`);
  }

  return response.json().catch(() => undefined);
}

import { isMarketingEvent } from './isMarketingEvent';
import { Tracker } from './Tracker';

export class ServerSideTracker implements Tracker {
  init() {}

  async trackEvent<T extends EventName>(
    event: T,
    properties: EventProperties<T>,
    anonymousId?: string,
  ) {
    // Marketing events are sent by FrontendTracker through posthog-js, after consent.
    if (isMarketingEvent(event)) {
      return;
    }
    try {
      await postData({
        url: '/api/tracking/event',
        data: {
          event,
          properties,
          anonymousId,
        },
      });
    } catch (error) {
      console.error('Error tracking event:', error);
    }
  }

  async identify(traits?: Record<string, any>, anonymousId?: string) {
    try {
      await postData({ url: '/api/tracking/identify', data: { ...traits, anonymousId } });
    } catch (error) {
      console.error('Error identifying user:', error);
    }
  }
}
